function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundcloudLogoinline = function SvgSoundcloudLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 13",
    style: {
      enableBackground: "new 0 0 29 13"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SoundcloudLogo_inline_svg__a",
    gradientUnits: "userSpaceOnUse",
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100.001%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#f79810"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f8310e"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1 11.6.5-2.1L1 7.4c0-.1-.1-.1-.3-.1-.1 0-.3 0-.3.1L0 9.5l.4 2.1c0 .1.1.1.3.1.1 0 .3 0 .3-.1zm2.9 1.2.4-3.2-.4-5c0-.1-.2-.2-.3-.2-.2 0-.3.1-.3.2l-.4 5 .4 3.2c0 .1.2.2.3.2.2 0 .3-.1.3-.2zm3-.1.3-3.1L6.9 3c0-.2-.2-.3-.4-.3s-.4.1-.4.3l-.3 6.6.3 3.1c0 .2.2.3.4.3s.4-.1.4-.3zm3 0 .3-3.1-.3-6.7c0-.2-.2-.3-.5-.3-.2 0-.4.1-.5.3l-.2 6.7.2 3.1c.1.1.3.3.5.3.3 0 .5-.2.5-.3zm2.9-.1.2-3.1-.2-7.5c0-.2-.2-.4-.5-.4s-.5.2-.5.4l-.2 7.6.2 3.1c0 .2.2.4.5.4.3-.1.5-.3.5-.5zm2.1.4h10.4c2.1 0 3.7-1.6 3.7-3.7 0-2-1.7-3.7-3.7-3.7-.5 0-1 .1-1.4.3-.4-3.3-3.2-5.9-6.7-5.9-.8 0-1.7.2-2.4.4-.3.1-.4.2-.4.4v11.7c.1.3.3.5.5.5z",
    style: {
      fill: "url(#SoundcloudLogo_inline_svg__a)"
    }
  }));
};
export default SvgSoundcloudLogoinline;